/**
 * Device families that live on a house room object. `key` is the array name on
 * the room, `type` is the value sent to the backend when the device is moved.
 */
export const DEVICE_GROUPS = [
  { key: 'energiSync', type: 'energiSync', label: 'EnergiSync', color: '#2050ff', bg: 'rgba(32,80,255,0.08)' },
  { key: 'megaControllers', type: 'megaControllers', label: 'MegaController', color: '#7c3aed', bg: 'rgba(124,58,237,0.08)' },
  { key: 'thermoSmarts', type: 'thermoSmarts', label: 'ThermoSmart', color: '#ef4444', bg: 'rgba(239,68,68,0.08)' },
  { key: 'environSyncs', type: 'environSyncs', label: 'EnvironSync', color: '#0ea5e9', bg: 'rgba(14,165,233,0.08)' },
  { key: 'weatherSensors', type: 'weatherSensors', label: 'Weather Sensor', color: '#f59e0b', bg: 'rgba(245,158,11,0.08)' },
  { key: 'doorSensors', type: 'doorSensors', label: 'Door Sensor', color: '#10b981', bg: 'rgba(16,185,129,0.08)' },
];

export const groupMeta = (key) =>
  DEVICE_GROUPS.find((group) => group.key === key) || { key, type: key, label: key, color: '#6b7280', bg: '#f3f4f6' };

export const theme = {
  accent: '#2050ff',
  accentSoft: 'rgba(32,80,255,0.08)',
  border: '#e5e7eb',
  text: '#111827',
  textMuted: '#6b7280',
  textFaint: '#9ca3af',
  surface: '#fff',
  surfaceMuted: '#f9fafb',
  danger: '#ef4444',
  success: '#10b981',
  font: 'Manrope',
};
